import { hydrateDropdowns } from "../utils/hydrate-dropdowns";
import { loadClientWidgets } from "../utils/loadClientWidgets";
import { widgetsFootball } from "../widgets";

import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";

export const initClient = () => loadClientWidgets(widgetsFootball);

initClient();

document.addEventListener('DOMContentLoaded', () => {
    hydrateDropdowns({
    tagsToExclude: [
      "ld-football-competition-calendar-results",
      "ld-football-team-calendar-results",
      "ld-football-match-reports-details",
      "ld-football-match-reports"
    ],
  });
});
